import React from "react";
import { Link} from "react-router-dom";
import { useLocation } from 'react-router-dom'
import "./SingleImage.css";

function SingleImage(props) {

    const location = useLocation()
    const { image, url } = location.state
    const { backToImage } = props;
    console.log(1, location.state)

    return (
        <div>
            <img className="single-img" alt="" src={image} />
            <Link to={url}>
                <div className="back-to-img lato-medium-white-13px">{backToImage}</div>
            </Link>
        </div>
    );
}

export default SingleImage;
